import { ProfileNotification } from '@dice/app/types/notification.types';
import { Profile } from '@dice/app/types/profile.types';

export namespace NotificationsActions {
  export class InitUserNotifications {
    static readonly type = '[NotificationsActions] InitUserNotifications';

    constructor(public profile: Profile) {}
  }
  export class AddNewUserNotification {
    static readonly type = '[NotificationsActions] AddNewNotification';

    constructor(public notification: ProfileNotification) {}
  }
  export class DeleteUserNotification {
    static readonly type = '[NotificationsActions] DeleteUserNotification';

    constructor(public notification: ProfileNotification) {}
  }
  export class DeleteAllNotifications {
    static readonly type = '[NotificationsActions] DeleteAllNotifications';
  }

  export class SetNotificationId {
    static readonly type = '[NotificationsActions] SetNotificationId';

    constructor(public notificationId: string) {}
  }
}
